'use strict';

angular.module('theme').component('shopBasket', {
	templateUrl: 'component/shop-basket.html',
	bindings: {
		public: '<'
	},
	controller: function ($rootScope, $timeout, ShopService) {
		var self = this;



		self.$onInit = function () {
			self.showToolTip = false;
			self.totalAmount = ShopService.getTotalCartAmount();
			self.setCheckoutUrl();
		};

		self.setCheckoutUrl = function () {
			if (!self.totalAmount || self.totalAmount == 0) {
				self.checkoutUrl = self.public ? '/shop/' : '/mypage/shop/';
			} else {
				self.checkoutUrl = self.public ? '/shop/checkout/' : '/mypage/shop/simple-checkout/';
			}
		};

		self.triggerToolTip = function () {
			self.showToolTip = true;
			$timeout(function () {
				self.showToolTip = false;
			}, 3000);
		};

		// Update orders when something changes
		$rootScope.$on('product-amount.update', function () {
			self.totalAmount = ShopService.getTotalCartAmount();
			self.setCheckoutUrl();
		});
		$rootScope.$on('shop-cart.update', function () {
			self.totalAmount = ShopService.getTotalCartAmount();
			self.setCheckoutUrl();
		});
		// Update orders when something changes
		$rootScope.$on('shop-cart.add', function () {
			self.triggerToolTip();
		});
	}
});